import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios, { API } from "@/lib/api";

const fmtAgo = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return "刚刚"; if (m < 60) return `${m} 分钟前`;
  const h = Math.floor(m / 60); return h < 24 ? `${h} 小时前` : `${Math.floor(h / 24)} 天前`;
};

// 👑 Who else on the super-admin team is logged in right now and which page they are looking at.
export const SuperTeamPresence = ({ me }) => {
  const loc = useLocation();
  const [team, setTeam] = useState([]);
  useEffect(() => {
    let alive = true;
    const ping = async () => {
      try {
        const title = (document.title || "").replace(/\s*[|·-]\s*Sellox.*$/i, "").trim();
        const r = await axios.post(`${API}/super/presence`, { path: loc.pathname, title }, { skipGlobalError: true, timeout: 8000 });
        if (alive) setTeam(r.data?.team || []);
      } catch { /* silent */ }
    };
    ping();
    const id = setInterval(ping, 60000);
    return () => { alive = false; clearInterval(id); };
  }, [loc.pathname]);
  const others = team.filter(t => t.username !== me);
  if (!others.length) return null;
  return (
    <div className="mt-2 space-y-1" data-testid="super-team-presence">
      {others.map(t => (
        <div key={t.username} className={`text-[11px] leading-snug rounded-md px-2 py-1 ${t.online ? "bg-emerald-500/10 text-emerald-300" : "bg-slate-800/60 text-slate-500"}`} data-testid={`presence-${t.username}`}>
          <span className={`inline-block w-1.5 h-1.5 rounded-full mr-1.5 ${t.online ? "bg-emerald-400 animate-pulse" : "bg-slate-600"}`} />
          👑 {t.name || t.username} {t.online ? "在线" : `离线 · ${fmtAgo(t.last_seen)}`}
          {t.online && t.path && <span className="block text-slate-400 truncate" title={t.path}>正在看 {t.title || t.path}</span>}
        </div>
      ))}
    </div>
  );
};
